import { Icon123, Icon24Hours, Icon3dCubeSphere, IconAddressBook, IconAdjustments, IconAlertCircle, IconAlignRight, IconAmbulance, IconAperture, IconApple, IconArmchair2, IconArrowLeft, IconArrowRight, IconArrowUpRight, IconArrowsCross, IconBabyCarriage, IconBackpack, IconBallBasketball, IconBan, IconBandage, IconBattery1, IconBeach, IconBed, IconBike, IconBolt, IconBomb, IconBone, IconBook2, IconBooks, IconBrain, IconBrandBadoo, IconBrandFacebook, IconBrandInstagram, IconBrandLinkedin, IconBrandWechat, IconBrandWindows, IconBrandX, IconBrandYoutube, IconBriefcase, IconBriefcaseOff, IconBug, IconBuilding, IconBuildingBridge2, IconBuildingCommunity, IconBuildingEstate, IconBuildingFactory2, IconBuildingHospital, IconBuildingSkyscraper, IconBuildingWarehouse, IconBuildingWindTurbine, IconBulb, IconBulbOff, IconBus, IconCalculator, IconCalendar, IconCalendarPlus, IconCalendarShare, IconCamper, IconCar, IconCarCrane, IconCarCrash, IconCaravan, IconCash, IconCashBanknote, IconCashBanknoteOff, IconCat, IconCertificate, IconChargingPile, IconChartHistogram, IconChartPie, IconCheck, IconChevronDown, IconChevronLeft, IconChevronRight, IconChevronUp, IconCircle, IconCircleArrowRight, IconCircleCheck, IconCircleDashed, IconCircleDot, IconCircleDotted, IconCircleKey, IconCircleLetterX, IconCircleNumber1, IconCircleNumber2, IconCircleNumber3, IconCircleOff, IconCircles, IconClock, IconClockExclamation, IconClockPause, IconCloudStorm, IconCloudUpload, IconCoins, IconCrane, IconCross, IconCrown, IconCrutches, IconDental, IconDentalBroken, IconDeviceDesktop, IconDeviceMobile, IconDeviceTv, IconDevices, IconDevicesBolt, IconDiamond, IconDisabled, IconDog, IconDoorExit, IconDots, IconDotsCircleHorizontal, IconDownload, IconDropCircle, IconDroplet, IconEdit, IconEngine, IconExternalLink, IconEye, IconEyeCheck, IconEyeOff, IconEyeglass, IconEyeglassOff, IconFaceMask, IconFall, IconFile, IconFileAlert, IconFileAnalytics, IconFileCheck, IconFileDescription, IconFileInfo, IconFilePower, IconFileSearch, IconFileSpreadsheet, IconFileTypeCsv, IconFileTypeDocx, IconFileTypeHtml, IconFileTypeJpg, IconFileTypePdf, IconFileTypePng, IconFileTypePpt, IconFileTypeSvg, IconFileTypeTxt, IconFileTypeXls, IconFileTypeZip, IconFiles, IconFirstAidKit, IconFlame, IconFlask2, IconFlipVertical, IconFlower, IconFold, IconFolder, IconFolderFilled, IconFolderOpen, IconFolderUp, IconFriends, IconGasStationOff, IconGavel, IconGift, IconGlassFull, IconGlobe, IconGolf, IconGrave2, IconHandFinger, IconHandOff, IconHeadphones, IconHeartBroken, IconHeartHandshake, IconHeartPlus, IconHeartbeat, IconHearts, IconHierarchy3, IconHome, IconHome2, IconHomeBolt, IconHomeEco, IconHomeHeart, IconHomeMove, IconHomeOff, IconHomePlus, IconHomeStar, IconHomeUp, IconHorseToy, IconHotelService, IconHourglassHigh, IconInfoCircle, IconKey, IconKeyOff, IconLeafOff, IconLifebuoy, IconLink, IconListDetails, IconLock, IconLogout, IconLuggage, IconLuggageOff, IconMail, IconMailBolt, IconMap2, IconMapPin, IconMatchstick, IconMedicalCross, IconMedicineSyrup, IconMenu2, IconMessageCircle2, IconMessageCircleHeart, IconMessageReport, IconMicroscope, IconMinus, IconMoneybag, IconMoodBoy, IconMoodDollar, IconMoodHeart, IconMoodKid, IconMoodNervous, IconMoodSadDizzy, IconMoodSmile, IconMoodSuprised, IconMoodWrrr, IconMoped, IconMotorbike, IconMushroom, IconNeedle, IconNews, IconNorthStar, IconNumber1, IconNumber2, IconNumber3, IconNurse, IconOld, IconPalette, IconPaperclip, IconParachute, IconParking, IconPercentage, IconPhone, IconPhoneCall, IconPhoto, IconPhysotherapist, IconPills, IconPlaneDeparture, IconPlaneOff, IconPlayCard, IconPlaystationCircle, IconPlugConnected, IconPlus, IconPrison, IconRecharging, IconRecycle, IconRefresh, IconRepeat, IconRoad, IconRobot, IconRocket, IconRotateClockwise, IconRotateClockwise2, IconRun, IconScaleOutline, IconSchool, IconSearch, IconSectionSign, IconSeeding, IconSelector, IconSend, IconShare, IconShiJumping, IconShield, IconShieldHalf, IconShieldHeart, IconShieldLock, IconShieldPlus, IconShirt, IconShovel, IconSkateboard, IconSkull, IconSlice, IconSnowflake, IconSofa, IconSolarPanel2, IconSos, IconSpeakerphone, IconSquareCheck, IconSquarePlus, IconStairsDown, IconSteeringWheel, IconStethoscope, IconStethoscopeOff, IconStretching, IconTag, IconTargetArrow, IconTemperaturePlus, IconThumbUp, IconTicket, IconTie, IconTimeline, IconTool, IconTrash, IconTrendingDown, IconTrendingUp, IconUmbrella, IconUser, IconUserBolt, IconUserEdit, IconUserHeart, IconUserPlus, IconUserSearch, IconUsersGroup, IconUsersPlus, IconVaccine, IconVirus, IconVocabulary, IconWall, IconWand, IconWash, IconWashDryShade, IconWifi, IconWoman, IconWorld, IconWorldCheck, IconWorldPin, IconWritingOff, IconWritingSign, IconX } from "@tabler/icons-react";
import { Icon123 as Icon1232, Icon24Hours as Icon24Hours2, Icon3dCubeSphere as Icon3dCubeSphere2, IconAddressBook as IconAddressBook2, IconAdjustments as IconAdjustments2, IconAlertCircle as IconAlertCircle2, IconAlignRight as IconAlignRight2, IconAmbulance as IconAmbulance2, IconAperture as IconAperture2, IconApple as IconApple2, IconArmchair2 as IconArmchair22, IconArrowLeft as IconArrowLeft2, IconArrowRight as IconArrowRight2, IconArrowUpRight as IconArrowUpRight2, IconArrowsCross as IconArrowsCross2, IconBabyCarriage as IconBabyCarriage2, IconBackpack as IconBackpack2, IconBallBasketball as IconBallBasketball2, IconBan as IconBan2, IconBandage as IconBandage2, IconBattery1 as IconBattery12, IconBeach as IconBeach2, IconBed as IconBed2, IconBike as IconBike2, IconBolt as IconBolt2, IconBomb as IconBomb2, IconBone as IconBone2, IconBook2 as IconBook22, IconBooks as IconBooks2, IconBrain as IconBrain2, IconBrandBadoo as IconBrandBadoo2, IconBrandFacebook as IconBrandFacebook2, IconBrandInstagram as IconBrandInstagram2, IconBrandLinkedin as IconBrandLinkedin2, IconBrandWechat as IconBrandWechat2, IconBrandWindows as IconBrandWindows2, IconBrandX as IconBrandX2, IconBrandYoutube as IconBrandYoutube2, IconBriefcase as IconBriefcase2, IconBriefcaseOff as IconBriefcaseOff2, IconBug as IconBug2, IconBuilding as IconBuilding2, IconBuildingBridge2 as IconBuildingBridge22, IconBuildingCommunity as IconBuildingCommunity2, IconBuildingEstate as IconBuildingEstate2, IconBuildingFactory2 as IconBuildingFactory22, IconBuildingHospital as IconBuildingHospital2, IconBuildingSkyscraper as IconBuildingSkyscraper2, IconBuildingWarehouse as IconBuildingWarehouse2, IconBuildingWindTurbine as IconBuildingWindTurbine2, IconBulb as IconBulb2, IconBulbOff as IconBulbOff2, IconBus as IconBus2, IconCalculator as IconCalculator2, IconCalendar as IconCalendar2, IconCalendarPlus as IconCalendarPlus2, IconCalendarShare as IconCalendarShare2, IconCamper as IconCamper2, IconCar as IconCar2, IconCarCrane as IconCarCrane2, IconCarCrash as IconCarCrash2, IconCaravan as IconCaravan2, IconCash as IconCash2, IconCashBanknote as IconCashBanknote2, IconCashBanknoteOff as IconCashBanknoteOff2, IconCat as IconCat2, IconCertificate as IconCertificate2, IconChargingPile as IconChargingPile2, IconChartHistogram as IconChartHistogram2, IconChartPie as IconChartPie2, IconCheck as IconCheck2, IconChevronDown as IconChevronDown2, IconChevronLeft as IconChevronLeft2, IconChevronRight as IconChevronRight2, IconChevronUp as IconChevronUp2, IconCircle as IconCircle2, IconCircleArrowRight as IconCircleArrowRight2, IconCircleCheck as IconCircleCheck2, IconCircleDashed as IconCircleDashed2, IconCircleDot as IconCircleDot2, IconCircleDotted as IconCircleDotted2, IconCircleKey as IconCircleKey2, IconCircleLetterX as IconCircleLetterX2, IconCircleNumber1 as IconCircleNumber12, IconCircleNumber2 as IconCircleNumber22, IconCircleNumber3 as IconCircleNumber32, IconCircleOff as IconCircleOff2, IconCircles as IconCircles2, IconClock as IconClock2, IconClockExclamation as IconClockExclamation2, IconClockPause as IconClockPause2, IconCloudStorm as IconCloudStorm2, IconCloudUpload as IconCloudUpload2, IconCoins as IconCoins2, IconCrane as IconCrane2, IconCross as IconCross2, IconCrown as IconCrown2, IconCrutches as IconCrutches2, IconDental as IconDental2, IconDentalBroken as IconDentalBroken2, IconDeviceDesktop as IconDeviceDesktop2, IconDeviceMobile as IconDeviceMobile2, IconDeviceTv as IconDeviceTv2, IconDevices as IconDevices2, IconDevicesBolt as IconDevicesBolt2, IconDiamond as IconDiamond2, IconDisabled as IconDisabled2, IconDog as IconDog2, IconDoorExit as IconDoorExit2, IconDots as IconDots2, IconDotsCircleHorizontal as IconDotsCircleHorizontal2, IconDownload as IconDownload2, IconDropCircle as IconDropCircle2, IconDroplet as IconDroplet2, IconEdit as IconEdit2, IconEngine as IconEngine2, IconExternalLink as IconExternalLink2, IconEye as IconEye2, IconEyeCheck as IconEyeCheck2, IconEyeOff as IconEyeOff2, IconEyeglass as IconEyeglass2, IconEyeglassOff as IconEyeglassOff2, IconFaceMask as IconFaceMask2, IconFall as IconFall2, IconFile as IconFile2, IconFileAlert as IconFileAlert2, IconFileAnalytics as IconFileAnalytics2, IconFileCheck as IconFileCheck2, IconFileDescription as IconFileDescription2, IconFileInfo as IconFileInfo2, IconFilePower as IconFilePower2, IconFileSearch as IconFileSearch2, IconFileSpreadsheet as IconFileSpreadsheet2, IconFileTypeCsv as IconFileTypeCsv2, IconFileTypeDocx as IconFileTypeDocx2, IconFileTypeHtml as IconFileTypeHtml2, IconFileTypeJpg as IconFileTypeJpg2, IconFileTypePdf as IconFileTypePdf2, IconFileTypePng as IconFileTypePng2, IconFileTypePpt as IconFileTypePpt2, IconFileTypeSvg as IconFileTypeSvg2, IconFileTypeTxt as IconFileTypeTxt2, IconFileTypeXls as IconFileTypeXls2, IconFileTypeZip as IconFileTypeZip2, IconFiles as IconFiles2, IconFirstAidKit as IconFirstAidKit2, IconFlame as IconFlame2, IconFlask2 as IconFlask22, IconFlipVertical as IconFlipVertical2, IconFlower as IconFlower2, IconFold as IconFold2, IconFolder as IconFolder2, IconFolderFilled as IconFolderFilled2, IconFolderOpen as IconFolderOpen2, IconFolderUp as IconFolderUp2, IconFriends as IconFriends2, IconGasStationOff as IconGasStationOff2, IconGavel as IconGavel2, IconGift as IconGift2, IconGlassFull as IconGlassFull2, IconGlobe as IconGlobe2, IconGolf as IconGolf2, IconGrave2 as IconGrave22, IconHandFinger as IconHandFinger2, IconHandOff as IconHandOff2, IconHeadphones as IconHeadphones2, IconHeartBroken as IconHeartBroken2, IconHeartHandshake as IconHeartHandshake2, IconHeartPlus as IconHeartPlus2, IconHeartbeat as IconHeartbeat2, IconHearts as IconHearts2, IconHierarchy3 as IconHierarchy32, IconHome as IconHome3, IconHome2 as IconHome22, IconHomeBolt as IconHomeBolt2, IconHomeEco as IconHomeEco2, IconHomeHeart as IconHomeHeart2, IconHomeMove as IconHomeMove2, IconHomeOff as IconHomeOff2, IconHomePlus as IconHomePlus2, IconHomeStar as IconHomeStar2, IconHomeUp as IconHomeUp2, IconHorseToy as IconHorseToy2, IconHotelService as IconHotelService2, IconHourglassHigh as IconHourglassHigh2, IconInfoCircle as IconInfoCircle2, IconKey as IconKey2, IconKeyOff as IconKeyOff2, IconLeafOff as IconLeafOff2, IconLifebuoy as IconLifebuoy2, IconLink as IconLink2, IconListDetails as IconListDetails2, IconLock as IconLock2, IconLogout as IconLogout2, IconLuggage as IconLuggage2, IconLuggageOff as IconLuggageOff2, IconMail as IconMail2, IconMailBolt as IconMailBolt2, IconMap2 as IconMap22, IconMapPin as IconMapPin2, IconMatchstick as IconMatchstick2, IconMedicalCross as IconMedicalCross2, IconMedicineSyrup as IconMedicineSyrup2, IconMenu2 as IconMenu22, IconMessageCircle2 as IconMessageCircle22, IconMessageCircleHeart as IconMessageCircleHeart2, IconMessageReport as IconMessageReport2, IconMicroscope as IconMicroscope2, IconMinus as IconMinus2, IconMoneybag as IconMoneybag2, IconMoodBoy as IconMoodBoy2, IconMoodDollar as IconMoodDollar2, IconMoodHeart as IconMoodHeart2, IconMoodKid as IconMoodKid2, IconMoodNervous as IconMoodNervous2, IconMoodSadDizzy as IconMoodSadDizzy2, IconMoodSmile as IconMoodSmile2, IconMoodSuprised as IconMoodSuprised2, IconMoodWrrr as IconMoodWrrr2, IconMoped as IconMoped2, IconMotorbike as IconMotorbike2, IconMushroom as IconMushroom2, IconNeedle as IconNeedle2, IconNews as IconNews2, IconNorthStar as IconNorthStar2, IconNumber1 as IconNumber12, IconNumber2 as IconNumber22, IconNumber3 as IconNumber32, IconNurse as IconNurse2, IconOld as IconOld2, IconPalette as IconPalette2, IconPaperclip as IconPaperclip2, IconParachute as IconParachute2, IconParking as IconParking2, IconPercentage as IconPercentage2, IconPhone as IconPhone2, IconPhoneCall as IconPhoneCall2, IconPhoto as IconPhoto2, IconPhysotherapist as IconPhysotherapist2, IconPills as IconPills2, IconPlaneDeparture as IconPlaneDeparture2, IconPlaneOff as IconPlaneOff2, IconPlayCard as IconPlayCard2, IconPlaystationCircle as IconPlaystationCircle2, IconPlugConnected as IconPlugConnected2, IconPlus as IconPlus2, IconPrison as IconPrison2, IconRecharging as IconRecharging2, IconRecycle as IconRecycle2, IconRefresh as IconRefresh2, IconRepeat as IconRepeat2, IconRoad as IconRoad2, IconRobot as IconRobot2, IconRocket as IconRocket2, IconRotateClockwise as IconRotateClockwise3, IconRotateClockwise2 as IconRotateClockwise22, IconRun as IconRun2, IconScaleOutline as IconScaleOutline2, IconSchool as IconSchool2, IconSearch as IconSearch2, IconSectionSign as IconSectionSign2, IconSeeding as IconSeeding2, IconSelector as IconSelector2, IconSend as IconSend2, IconShare as IconShare2, IconShiJumping as IconShiJumping2, IconShield as IconShield2, IconShieldHalf as IconShieldHalf2, IconShieldHeart as IconShieldHeart2, IconShieldLock as IconShieldLock2, IconShieldPlus as IconShieldPlus2, IconShirt as IconShirt2, IconShovel as IconShovel2, IconSkateboard as IconSkateboard2, IconSkull as IconSkull2, IconSlice as IconSlice2, IconSnowflake as IconSnowflake2, IconSofa as IconSofa2, IconSolarPanel2 as IconSolarPanel22, IconSos as IconSos2, IconSpeakerphone as IconSpeakerphone2, IconSquareCheck as IconSquareCheck2, IconSquarePlus as IconSquarePlus2, IconStairsDown as IconStairsDown2, IconSteeringWheel as IconSteeringWheel2, IconStethoscope as IconStethoscope2, IconStethoscopeOff as IconStethoscopeOff2, IconStretching as IconStretching2, IconTag as IconTag2, IconTargetArrow as IconTargetArrow2, IconTemperaturePlus as IconTemperaturePlus2, IconThumbUp as IconThumbUp2, IconTicket as IconTicket2, IconTie as IconTie2, IconTimeline as IconTimeline2, IconTool as IconTool2, IconTrash as IconTrash2, IconTrendingDown as IconTrendingDown2, IconTrendingUp as IconTrendingUp2, IconUmbrella as IconUmbrella2, IconUser as IconUser2, IconUserBolt as IconUserBolt2, IconUserEdit as IconUserEdit2, IconUserHeart as IconUserHeart2, IconUserPlus as IconUserPlus2, IconUserSearch as IconUserSearch2, IconUsersGroup as IconUsersGroup2, IconUsersPlus as IconUsersPlus2, IconVaccine as IconVaccine2, IconVirus as IconVirus2, IconVocabulary as IconVocabulary2, IconWall as IconWall2, IconWand as IconWand2, IconWash as IconWash2, IconWashDryShade as IconWashDryShade2, IconWifi as IconWifi2, IconWoman as IconWoman2, IconWorld as IconWorld2, IconWorldCheck as IconWorldCheck2, IconWorldPin as IconWorldPin2, IconWritingOff as IconWritingOff2, IconWritingSign as IconWritingSign2, IconX as IconX2 } from "@tabler/icons-react";
const IconList = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Icon123,
  Icon24Hours,
  Icon3dCubeSphere,
  IconAddressBook,
  IconAdjustments,
  IconAlertCircle,
  IconAlignRight,
  IconAmbulance,
  IconAperture,
  IconApple,
  IconArmchair2,
  IconArrowLeft,
  IconArrowRight,
  IconArrowUpRight,
  IconArrowsCross,
  IconBabyCarriage,
  IconBackpack,
  IconBallBasketball,
  IconBan,
  IconBandage,
  IconBattery1,
  IconBeach,
  IconBed,
  IconBike,
  IconBolt,
  IconBomb,
  IconBone,
  IconBook2,
  IconBooks,
  IconBrain,
  IconBrandBadoo,
  IconBrandFacebook,
  IconBrandInstagram,
  IconBrandLinkedin,
  IconBrandWechat,
  IconBrandWindows,
  IconBrandX,
  IconBrandYoutube,
  IconBriefcase,
  IconBriefcaseOff,
  IconBug,
  IconBuilding,
  IconBuildingBridge2,
  IconBuildingCommunity,
  IconBuildingEstate,
  IconBuildingFactory2,
  IconBuildingHospital,
  IconBuildingSkyscraper,
  IconBuildingWarehouse,
  IconBuildingWindTurbine,
  IconBulb,
  IconBulbOff,
  IconBus,
  IconCalculator,
  IconCalendar,
  IconCalendarPlus,
  IconCalendarShare,
  IconCamper,
  IconCar,
  IconCarCrane,
  IconCarCrash,
  IconCaravan,
  IconCash,
  IconCashBanknote,
  IconCashBanknoteOff,
  IconCat,
  IconCertificate,
  IconChargingPile,
  IconChartHistogram,
  IconChartPie,
  IconCheck,
  IconChevronDown,
  IconChevronLeft,
  IconChevronRight,
  IconChevronUp,
  IconCircle,
  IconCircleArrowRight,
  IconCircleCheck,
  IconCircleDashed,
  IconCircleDot,
  IconCircleDotted,
  IconCircleKey,
  IconCircleLetterX,
  IconCircleNumber1,
  IconCircleNumber2,
  IconCircleNumber3,
  IconCircleOff,
  IconCircles,
  IconClock,
  IconClockExclamation,
  IconClockPause,
  IconCloudStorm,
  IconCloudUpload,
  IconCoins,
  IconCrane,
  IconCross,
  IconCrown,
  IconCrutches,
  IconDental,
  IconDentalBroken,
  IconDeviceDesktop,
  IconDeviceMobile,
  IconDeviceTv,
  IconDevices,
  IconDevicesBolt,
  IconDiamond,
  IconDisabled,
  IconDog,
  IconDoorExit,
  IconDots,
  IconDotsCircleHorizontal,
  IconDownload,
  IconDropCircle,
  IconDroplet,
  IconEdit,
  IconEngine,
  IconExternalLink,
  IconEye,
  IconEyeCheck,
  IconEyeOff,
  IconEyeglass,
  IconEyeglassOff,
  IconFaceMask,
  IconFall,
  IconFile,
  IconFileAlert,
  IconFileAnalytics,
  IconFileCheck,
  IconFileDescription,
  IconFileInfo,
  IconFilePower,
  IconFileSearch,
  IconFileSpreadsheet,
  IconFileTypeCsv,
  IconFileTypeDocx,
  IconFileTypeHtml,
  IconFileTypeJpg,
  IconFileTypePdf,
  IconFileTypePng,
  IconFileTypePpt,
  IconFileTypeSvg,
  IconFileTypeTxt,
  IconFileTypeXls,
  IconFileTypeZip,
  IconFiles,
  IconFirstAidKit,
  IconFlame,
  IconFlask2,
  IconFlipVertical,
  IconFlower,
  IconFold,
  IconFolder,
  IconFolderFilled,
  IconFolderOpen,
  IconFolderUp,
  IconFriends,
  IconGasStationOff,
  IconGavel,
  IconGift,
  IconGlassFull,
  IconGlobe,
  IconGolf,
  IconGrave2,
  IconHandFinger,
  IconHandOff,
  IconHeadphones,
  IconHeartBroken,
  IconHeartHandshake,
  IconHeartPlus,
  IconHeartbeat,
  IconHearts,
  IconHierarchy3,
  IconHome,
  IconHome2,
  IconHomeBolt,
  IconHomeEco,
  IconHomeHeart,
  IconHomeMove,
  IconHomeOff,
  IconHomePlus,
  IconHomeStar,
  IconHomeUp,
  IconHorseToy,
  IconHotelService,
  IconHourglassHigh,
  IconInfoCircle,
  IconKey,
  IconKeyOff,
  IconLeafOff,
  IconLifebuoy,
  IconLink,
  IconListDetails,
  IconLock,
  IconLogout,
  IconLuggage,
  IconLuggageOff,
  IconMail,
  IconMailBolt,
  IconMap2,
  IconMapPin,
  IconMatchstick,
  IconMedicalCross,
  IconMedicineSyrup,
  IconMenu2,
  IconMessageCircle2,
  IconMessageCircleHeart,
  IconMessageReport,
  IconMicroscope,
  IconMinus,
  IconMoneybag,
  IconMoodBoy,
  IconMoodDollar,
  IconMoodHeart,
  IconMoodKid,
  IconMoodNervous,
  IconMoodSadDizzy,
  IconMoodSmile,
  IconMoodSuprised,
  IconMoodWrrr,
  IconMoped,
  IconMotorbike,
  IconMushroom,
  IconNeedle,
  IconNews,
  IconNorthStar,
  IconNumber1,
  IconNumber2,
  IconNumber3,
  IconNurse,
  IconOld,
  IconPalette,
  IconPaperclip,
  IconParachute,
  IconParking,
  IconPercentage,
  IconPhone,
  IconPhoneCall,
  IconPhoto,
  IconPhysotherapist,
  IconPills,
  IconPlaneDeparture,
  IconPlaneOff,
  IconPlayCard,
  IconPlaystationCircle,
  IconPlugConnected,
  IconPlus,
  IconPrison,
  IconRecharging,
  IconRecycle,
  IconRefresh,
  IconRepeat,
  IconRoad,
  IconRobot,
  IconRocket,
  IconRotateClockwise,
  IconRotateClockwise2,
  IconRun,
  IconScaleOutline,
  IconSchool,
  IconSearch,
  IconSectionSign,
  IconSeeding,
  IconSelector,
  IconSend,
  IconShare,
  IconShiJumping,
  IconShield,
  IconShieldHalf,
  IconShieldHeart,
  IconShieldLock,
  IconShieldPlus,
  IconShirt,
  IconShovel,
  IconSkateboard,
  IconSkull,
  IconSlice,
  IconSnowflake,
  IconSofa,
  IconSolarPanel2,
  IconSos,
  IconSpeakerphone,
  IconSquareCheck,
  IconSquarePlus,
  IconStairsDown,
  IconSteeringWheel,
  IconStethoscope,
  IconStethoscopeOff,
  IconStretching,
  IconTag,
  IconTargetArrow,
  IconTemperaturePlus,
  IconThumbUp,
  IconTicket,
  IconTie,
  IconTimeline,
  IconTool,
  IconTrash,
  IconTrendingDown,
  IconTrendingUp,
  IconUmbrella,
  IconUser,
  IconUserBolt,
  IconUserEdit,
  IconUserHeart,
  IconUserPlus,
  IconUserSearch,
  IconUsersGroup,
  IconUsersPlus,
  IconVaccine,
  IconVirus,
  IconVocabulary,
  IconWall,
  IconWand,
  IconWash,
  IconWashDryShade,
  IconWifi,
  IconWoman,
  IconWorld,
  IconWorldCheck,
  IconWorldPin,
  IconWritingOff,
  IconWritingSign,
  IconX
}, Symbol.toStringTag, { value: "Module" }));
export {
  IconList as I,
  Icon1232 as Icon123,
  Icon24Hours2 as Icon24Hours,
  Icon3dCubeSphere2 as Icon3dCubeSphere,
  IconAddressBook2 as IconAddressBook,
  IconAdjustments2 as IconAdjustments,
  IconAlertCircle2 as IconAlertCircle,
  IconAlignRight2 as IconAlignRight,
  IconAmbulance2 as IconAmbulance,
  IconAperture2 as IconAperture,
  IconApple2 as IconApple,
  IconArmchair22 as IconArmchair2,
  IconArrowLeft2 as IconArrowLeft,
  IconArrowRight2 as IconArrowRight,
  IconArrowUpRight2 as IconArrowUpRight,
  IconArrowsCross2 as IconArrowsCross,
  IconBabyCarriage2 as IconBabyCarriage,
  IconBackpack2 as IconBackpack,
  IconBallBasketball2 as IconBallBasketball,
  IconBan2 as IconBan,
  IconBandage2 as IconBandage,
  IconBattery12 as IconBattery1,
  IconBeach2 as IconBeach,
  IconBed2 as IconBed,
  IconBike2 as IconBike,
  IconBolt2 as IconBolt,
  IconBomb2 as IconBomb,
  IconBone2 as IconBone,
  IconBook22 as IconBook2,
  IconBooks2 as IconBooks,
  IconBrain2 as IconBrain,
  IconBrandBadoo2 as IconBrandBadoo,
  IconBrandFacebook2 as IconBrandFacebook,
  IconBrandInstagram2 as IconBrandInstagram,
  IconBrandLinkedin2 as IconBrandLinkedin,
  IconBrandWechat2 as IconBrandWechat,
  IconBrandWindows2 as IconBrandWindows,
  IconBrandX2 as IconBrandX,
  IconBrandYoutube2 as IconBrandYoutube,
  IconBriefcase2 as IconBriefcase,
  IconBriefcaseOff2 as IconBriefcaseOff,
  IconBug2 as IconBug,
  IconBuilding2 as IconBuilding,
  IconBuildingBridge22 as IconBuildingBridge2,
  IconBuildingCommunity2 as IconBuildingCommunity,
  IconBuildingEstate2 as IconBuildingEstate,
  IconBuildingFactory22 as IconBuildingFactory2,
  IconBuildingHospital2 as IconBuildingHospital,
  IconBuildingSkyscraper2 as IconBuildingSkyscraper,
  IconBuildingWarehouse2 as IconBuildingWarehouse,
  IconBuildingWindTurbine2 as IconBuildingWindTurbine,
  IconBulb2 as IconBulb,
  IconBulbOff2 as IconBulbOff,
  IconBus2 as IconBus,
  IconCalculator2 as IconCalculator,
  IconCalendar2 as IconCalendar,
  IconCalendarPlus2 as IconCalendarPlus,
  IconCalendarShare2 as IconCalendarShare,
  IconCamper2 as IconCamper,
  IconCar2 as IconCar,
  IconCarCrane2 as IconCarCrane,
  IconCarCrash2 as IconCarCrash,
  IconCaravan2 as IconCaravan,
  IconCash2 as IconCash,
  IconCashBanknote2 as IconCashBanknote,
  IconCashBanknoteOff2 as IconCashBanknoteOff,
  IconCat2 as IconCat,
  IconCertificate2 as IconCertificate,
  IconChargingPile2 as IconChargingPile,
  IconChartHistogram2 as IconChartHistogram,
  IconChartPie2 as IconChartPie,
  IconCheck2 as IconCheck,
  IconChevronDown2 as IconChevronDown,
  IconChevronLeft2 as IconChevronLeft,
  IconChevronRight2 as IconChevronRight,
  IconChevronUp2 as IconChevronUp,
  IconCircle2 as IconCircle,
  IconCircleArrowRight2 as IconCircleArrowRight,
  IconCircleCheck2 as IconCircleCheck,
  IconCircleDashed2 as IconCircleDashed,
  IconCircleDot2 as IconCircleDot,
  IconCircleDotted2 as IconCircleDotted,
  IconCircleKey2 as IconCircleKey,
  IconCircleLetterX2 as IconCircleLetterX,
  IconCircleNumber12 as IconCircleNumber1,
  IconCircleNumber22 as IconCircleNumber2,
  IconCircleNumber32 as IconCircleNumber3,
  IconCircleOff2 as IconCircleOff,
  IconCircles2 as IconCircles,
  IconClock2 as IconClock,
  IconClockExclamation2 as IconClockExclamation,
  IconClockPause2 as IconClockPause,
  IconCloudStorm2 as IconCloudStorm,
  IconCloudUpload2 as IconCloudUpload,
  IconCoins2 as IconCoins,
  IconCrane2 as IconCrane,
  IconCross2 as IconCross,
  IconCrown2 as IconCrown,
  IconCrutches2 as IconCrutches,
  IconDental2 as IconDental,
  IconDentalBroken2 as IconDentalBroken,
  IconDeviceDesktop2 as IconDeviceDesktop,
  IconDeviceMobile2 as IconDeviceMobile,
  IconDeviceTv2 as IconDeviceTv,
  IconDevices2 as IconDevices,
  IconDevicesBolt2 as IconDevicesBolt,
  IconDiamond2 as IconDiamond,
  IconDisabled2 as IconDisabled,
  IconDog2 as IconDog,
  IconDoorExit2 as IconDoorExit,
  IconDots2 as IconDots,
  IconDotsCircleHorizontal2 as IconDotsCircleHorizontal,
  IconDownload2 as IconDownload,
  IconDropCircle2 as IconDropCircle,
  IconDroplet2 as IconDroplet,
  IconEdit2 as IconEdit,
  IconEngine2 as IconEngine,
  IconExternalLink2 as IconExternalLink,
  IconEye2 as IconEye,
  IconEyeCheck2 as IconEyeCheck,
  IconEyeOff2 as IconEyeOff,
  IconEyeglass2 as IconEyeglass,
  IconEyeglassOff2 as IconEyeglassOff,
  IconFaceMask2 as IconFaceMask,
  IconFall2 as IconFall,
  IconFile2 as IconFile,
  IconFileAlert2 as IconFileAlert,
  IconFileAnalytics2 as IconFileAnalytics,
  IconFileCheck2 as IconFileCheck,
  IconFileDescription2 as IconFileDescription,
  IconFileInfo2 as IconFileInfo,
  IconFilePower2 as IconFilePower,
  IconFileSearch2 as IconFileSearch,
  IconFileSpreadsheet2 as IconFileSpreadsheet,
  IconFileTypeCsv2 as IconFileTypeCsv,
  IconFileTypeDocx2 as IconFileTypeDocx,
  IconFileTypeHtml2 as IconFileTypeHtml,
  IconFileTypeJpg2 as IconFileTypeJpg,
  IconFileTypePdf2 as IconFileTypePdf,
  IconFileTypePng2 as IconFileTypePng,
  IconFileTypePpt2 as IconFileTypePpt,
  IconFileTypeSvg2 as IconFileTypeSvg,
  IconFileTypeTxt2 as IconFileTypeTxt,
  IconFileTypeXls2 as IconFileTypeXls,
  IconFileTypeZip2 as IconFileTypeZip,
  IconFiles2 as IconFiles,
  IconFirstAidKit2 as IconFirstAidKit,
  IconFlame2 as IconFlame,
  IconFlask22 as IconFlask2,
  IconFlipVertical2 as IconFlipVertical,
  IconFlower2 as IconFlower,
  IconFold2 as IconFold,
  IconFolder2 as IconFolder,
  IconFolderFilled2 as IconFolderFilled,
  IconFolderOpen2 as IconFolderOpen,
  IconFolderUp2 as IconFolderUp,
  IconFriends2 as IconFriends,
  IconGasStationOff2 as IconGasStationOff,
  IconGavel2 as IconGavel,
  IconGift2 as IconGift,
  IconGlassFull2 as IconGlassFull,
  IconGlobe2 as IconGlobe,
  IconGolf2 as IconGolf,
  IconGrave22 as IconGrave2,
  IconHandFinger2 as IconHandFinger,
  IconHandOff2 as IconHandOff,
  IconHeadphones2 as IconHeadphones,
  IconHeartBroken2 as IconHeartBroken,
  IconHeartHandshake2 as IconHeartHandshake,
  IconHeartPlus2 as IconHeartPlus,
  IconHeartbeat2 as IconHeartbeat,
  IconHearts2 as IconHearts,
  IconHierarchy32 as IconHierarchy3,
  IconHome3 as IconHome,
  IconHome22 as IconHome2,
  IconHomeBolt2 as IconHomeBolt,
  IconHomeEco2 as IconHomeEco,
  IconHomeHeart2 as IconHomeHeart,
  IconHomeMove2 as IconHomeMove,
  IconHomeOff2 as IconHomeOff,
  IconHomePlus2 as IconHomePlus,
  IconHomeStar2 as IconHomeStar,
  IconHomeUp2 as IconHomeUp,
  IconHorseToy2 as IconHorseToy,
  IconHotelService2 as IconHotelService,
  IconHourglassHigh2 as IconHourglassHigh,
  IconInfoCircle2 as IconInfoCircle,
  IconKey2 as IconKey,
  IconKeyOff2 as IconKeyOff,
  IconLeafOff2 as IconLeafOff,
  IconLifebuoy2 as IconLifebuoy,
  IconLink2 as IconLink,
  IconListDetails2 as IconListDetails,
  IconLock2 as IconLock,
  IconLogout2 as IconLogout,
  IconLuggage2 as IconLuggage,
  IconLuggageOff2 as IconLuggageOff,
  IconMail2 as IconMail,
  IconMailBolt2 as IconMailBolt,
  IconMap22 as IconMap2,
  IconMapPin2 as IconMapPin,
  IconMatchstick2 as IconMatchstick,
  IconMedicalCross2 as IconMedicalCross,
  IconMedicineSyrup2 as IconMedicineSyrup,
  IconMenu22 as IconMenu2,
  IconMessageCircle22 as IconMessageCircle2,
  IconMessageCircleHeart2 as IconMessageCircleHeart,
  IconMessageReport2 as IconMessageReport,
  IconMicroscope2 as IconMicroscope,
  IconMinus2 as IconMinus,
  IconMoneybag2 as IconMoneybag,
  IconMoodBoy2 as IconMoodBoy,
  IconMoodDollar2 as IconMoodDollar,
  IconMoodHeart2 as IconMoodHeart,
  IconMoodKid2 as IconMoodKid,
  IconMoodNervous2 as IconMoodNervous,
  IconMoodSadDizzy2 as IconMoodSadDizzy,
  IconMoodSmile2 as IconMoodSmile,
  IconMoodSuprised2 as IconMoodSuprised,
  IconMoodWrrr2 as IconMoodWrrr,
  IconMoped2 as IconMoped,
  IconMotorbike2 as IconMotorbike,
  IconMushroom2 as IconMushroom,
  IconNeedle2 as IconNeedle,
  IconNews2 as IconNews,
  IconNorthStar2 as IconNorthStar,
  IconNumber12 as IconNumber1,
  IconNumber22 as IconNumber2,
  IconNumber32 as IconNumber3,
  IconNurse2 as IconNurse,
  IconOld2 as IconOld,
  IconPalette2 as IconPalette,
  IconPaperclip2 as IconPaperclip,
  IconParachute2 as IconParachute,
  IconParking2 as IconParking,
  IconPercentage2 as IconPercentage,
  IconPhone2 as IconPhone,
  IconPhoneCall2 as IconPhoneCall,
  IconPhoto2 as IconPhoto,
  IconPhysotherapist2 as IconPhysotherapist,
  IconPills2 as IconPills,
  IconPlaneDeparture2 as IconPlaneDeparture,
  IconPlaneOff2 as IconPlaneOff,
  IconPlayCard2 as IconPlayCard,
  IconPlaystationCircle2 as IconPlaystationCircle,
  IconPlugConnected2 as IconPlugConnected,
  IconPlus2 as IconPlus,
  IconPrison2 as IconPrison,
  IconRecharging2 as IconRecharging,
  IconRecycle2 as IconRecycle,
  IconRefresh2 as IconRefresh,
  IconRepeat2 as IconRepeat,
  IconRoad2 as IconRoad,
  IconRobot2 as IconRobot,
  IconRocket2 as IconRocket,
  IconRotateClockwise3 as IconRotateClockwise,
  IconRotateClockwise22 as IconRotateClockwise2,
  IconRun2 as IconRun,
  IconScaleOutline2 as IconScaleOutline,
  IconSchool2 as IconSchool,
  IconSearch2 as IconSearch,
  IconSectionSign2 as IconSectionSign,
  IconSeeding2 as IconSeeding,
  IconSelector2 as IconSelector,
  IconSend2 as IconSend,
  IconShare2 as IconShare,
  IconShiJumping2 as IconShiJumping,
  IconShield2 as IconShield,
  IconShieldHalf2 as IconShieldHalf,
  IconShieldHeart2 as IconShieldHeart,
  IconShieldLock2 as IconShieldLock,
  IconShieldPlus2 as IconShieldPlus,
  IconShirt2 as IconShirt,
  IconShovel2 as IconShovel,
  IconSkateboard2 as IconSkateboard,
  IconSkull2 as IconSkull,
  IconSlice2 as IconSlice,
  IconSnowflake2 as IconSnowflake,
  IconSofa2 as IconSofa,
  IconSolarPanel22 as IconSolarPanel2,
  IconSos2 as IconSos,
  IconSpeakerphone2 as IconSpeakerphone,
  IconSquareCheck2 as IconSquareCheck,
  IconSquarePlus2 as IconSquarePlus,
  IconStairsDown2 as IconStairsDown,
  IconSteeringWheel2 as IconSteeringWheel,
  IconStethoscope2 as IconStethoscope,
  IconStethoscopeOff2 as IconStethoscopeOff,
  IconStretching2 as IconStretching,
  IconTag2 as IconTag,
  IconTargetArrow2 as IconTargetArrow,
  IconTemperaturePlus2 as IconTemperaturePlus,
  IconThumbUp2 as IconThumbUp,
  IconTicket2 as IconTicket,
  IconTie2 as IconTie,
  IconTimeline2 as IconTimeline,
  IconTool2 as IconTool,
  IconTrash2 as IconTrash,
  IconTrendingDown2 as IconTrendingDown,
  IconTrendingUp2 as IconTrendingUp,
  IconUmbrella2 as IconUmbrella,
  IconUser2 as IconUser,
  IconUserBolt2 as IconUserBolt,
  IconUserEdit2 as IconUserEdit,
  IconUserHeart2 as IconUserHeart,
  IconUserPlus2 as IconUserPlus,
  IconUserSearch2 as IconUserSearch,
  IconUsersGroup2 as IconUsersGroup,
  IconUsersPlus2 as IconUsersPlus,
  IconVaccine2 as IconVaccine,
  IconVirus2 as IconVirus,
  IconVocabulary2 as IconVocabulary,
  IconWall2 as IconWall,
  IconWand2 as IconWand,
  IconWash2 as IconWash,
  IconWashDryShade2 as IconWashDryShade,
  IconWifi2 as IconWifi,
  IconWoman2 as IconWoman,
  IconWorld2 as IconWorld,
  IconWorldCheck2 as IconWorldCheck,
  IconWorldPin2 as IconWorldPin,
  IconWritingOff2 as IconWritingOff,
  IconWritingSign2 as IconWritingSign,
  IconX2 as IconX
};
